import { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { Skeleton } from "@mui/material";

import { STRIPE_API_KEY } from "@/config";
import { request } from "@/Api";
import PaymentUpdateForm from "@/payment/PaymentUpdateForm";

// Call this outside render to avoid recreating the `Stripe` object on every render
const stripePromise = loadStripe(STRIPE_API_KEY);

export default function PaymentUpdate({ handleSuccess }) {
    const [loading, setLoading] = useState(true);
    const [clientSecret, setClientSecret] = useState(null);

    useEffect(() => {
        if (updateMode && !clientSecret) {
            request.post("/payments/setup-intent").then((response) => {
                setClientSecret(response.data);
                setLoading(false);
            });
        }
    }, []);

    return (
        <div style={{ minHeight: updateMode ? "372px" : "476px" }}>
            {loading ? (
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={updateMode ? 372 : 476}
                />
            ) : (
                <Elements
                    stripe={stripePromise}
                    options={{
                        clientSecret: clientSecret,
                        appearance: { theme: "flat" },
                    }}
                >
                    <PaymentUpdateForm handleSuccess={handleSuccess} />
                </Elements>
            )}
        </div>
    );
}
